module.exports = __webpack_public_path__ + "img/hr-garballo-10.167f6956.png";